import React, { useState } from "react";

import { Button, Grid, Typography } from "@mui/material";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  HeatingWaterDetail,
  HeatingWaterDetailItem,
  emptyHeatingWater,
} from "components/forms/HeatingWaterDetail";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { createHeatingWater } from "api/automation";

export const CreateHeatingWater = ({ history }) => {
  const { currentSpace, currentEnvironment, token } = useUserContext();
  const setError = useSetError();

  const [heatingWaterData, setHeatingWaterData] = useState<
    HeatingWaterDetailItem[]
  >([{ ...emptyHeatingWater }]);

  const handleSubmit = async () => {
    if (heatingWaterData?.length && currentEnvironment?.id) {
      try {
        await createHeatingWater(
          token,
          currentEnvironment.id,
          heatingWaterData
        );
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error);
      }
    } else {
      setError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const handleAdd = () => {
    setHeatingWaterData((prev) => [...prev, { ...emptyHeatingWater }]);
  };

  const handleHeatingWaterUpdate = (
    updated: HeatingWaterDetailItem,
    position: number
  ) => {
    if (heatingWaterData?.length) {
      const updatedData = [...heatingWaterData];
      updatedData.splice(position, 1, updated);
      setHeatingWaterData(updatedData);
    }
  };

  const handleHeatingWaterDelete = (position: number) => {
    const updatedData = [...heatingWaterData];
    updatedData.splice(position, 1);
    setHeatingWaterData(updatedData);
  };

  return (
    <PageStandard title="Aquecimento e água" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      {!!heatingWaterData?.length &&
        heatingWaterData.map((item, position) => {
          return (
            <HeatingWaterDetail
              key={position}
              heatingWaterData={item}
              heatingWaterPos={position}
              onChange={(updated) =>
                handleHeatingWaterUpdate(updated, position)
              }
              onDelete={() => handleHeatingWaterDelete(position)}
            />
          );
        })}

      {!!heatingWaterData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de aquecimento e água
        </Button>
      )}
    </PageStandard>
  );
};
